module.exports = __webpack_public_path__ + "media/img/frontend_application/content_production/other_service_one-01ee3f32826646554ba2611a96402d3d.png";